import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export type ManipulateType = dayjs.ManipulateType;

export type SpenditDateType = dayjs.Dayjs;

const originalDayjs = dayjs;

originalDayjs.extend(isSameOrBefore);
originalDayjs.extend(isSameOrAfter);
originalDayjs.extend(quarterOfYear);
originalDayjs.extend(customParseFormat);
originalDayjs.extend(utc);
originalDayjs.extend(timezone);

const iso8601Regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z|[+-]\d{2}:\d{2})?$/;

const normalizeDateString = (value: string) => (iso8601Regex.test(value) ? value : value.replace(/[-.]/g, '/'));

function spenditDate(date?: dayjs.ConfigType, format?: string, locale?: string, strict?: boolean): dayjs.Dayjs {
  if (format !== undefined) {
    return originalDayjs(date, format, locale, strict);
  }

  if (typeof date === 'string') {
    return originalDayjs(normalizeDateString(date));
  }

  return originalDayjs(date);
}

export default spenditDate;
